export enum DrawerType {
    MERGE_CASES,
    CREATE_CASES
 }